import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row my-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 border fw-bold" }, "Конструктив", -1)
const _hoisted_3 = { class: "col-4 fw-bold row" }
const _hoisted_4 = { class: "col-12 border text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 border" }, "Ремонт", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 border" }, "Замена", -1)
const _hoisted_7 = { class: "col-4 fw-bold row" }
const _hoisted_8 = { class: "col-12 border text-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 border" }, "Ремонт", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 border" }, "Замена", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 border fw-bold" }, "Сумма без НДС", -1)
const _hoisted_12 = { class: "col-2 border d-flex align-items-center" }
const _hoisted_13 = { class: "col-2 border" }
const _hoisted_14 = { class: "col-2 border" }
const _hoisted_15 = { class: "col-2 border" }
const _hoisted_16 = { class: "col-2 border" }
const _hoisted_17 = { class: "col-2 border d-flex align-items-center" }
const _hoisted_18 = { class: "row my-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 border fw-bold" }, " Итого ", -1)
const _hoisted_20 = { class: "col-2 border fw-bold" }
const _hoisted_21 = { class: "col-2 border fw-bold" }
const _hoisted_22 = { class: "col-2 border fw-bold" }
const _hoisted_23 = { class: "col-2 border fw-bold" }
const _hoisted_24 = { class: "col-2 border fw-bold" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 border d-flex align-items-center" }, " в т.ч. неофиц. расходы (КЭШ) ", -1)
const _hoisted_27 = { class: "col-2 border" }
const _hoisted_28 = { class: "col-6 border" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-12 text-center" }

import { onMounted, reactive, computed, ref } from 'vue';
import { PRICE_NAME } from '@depo/constants/project-register';
import { useModal } from '@/composables/useModal';
import api from '@/api';
import { IConstructive } from '@/@types/ISummary';
import formatMoney from '@/utils/formatMoney';

type constructivePriceType = {
  constructiveId: number;
  constructiveName: string;
  constructiveNumber: string;
  projectRegisterId: number;
  ['Товары']: {
    replacementPrice: number;
    repairPrice: number;
  };
  ['Услуги']: {
    replacementPrice: number;
    repairPrice: number;
  };
};

type stateType = {
  constructivePrices: Array<constructivePriceType>;
  constructivePriceCachePercent: string;
  visibleErrors: boolean;
  loader: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectRegisterPriceModal',
  props: {
  id: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props;

const modal = useModal(props.id);

const state: stateType = reactive({
  constructivePrices: [],
  constructivePriceCachePercent: '',
  visibleErrors: false,
  loader: false,
});

const constructives = ref<IConstructive[]>([]);

const getItemTotal = computed(() => (constructivePrice: constructivePriceType) => {
  const goods = +constructivePrice['Товары'].replacementPrice + +constructivePrice['Товары'].repairPrice;
  const services = +constructivePrice['Услуги'].replacementPrice + +constructivePrice['Услуги'].repairPrice;
  return goods + services;
});

const goodsRepairPrice = computed(() => {
  return state.constructivePrices.reduce((total, curVal) => {
    return total + +curVal['Товары'].repairPrice;
  }, 0);
})

const goodsReplacementPrice = computed(() => {
  return state.constructivePrices.reduce((total, curVal) => {
    return total + +curVal['Товары'].replacementPrice;
  }, 0);
})

const servicesRepairPrice = computed(() => {
  return state.constructivePrices.reduce((total, curVal) => {
    return total + +curVal['Услуги'].repairPrice;
  }, 0);
})

const servicesReplacementPrice = computed(() => {
  return state.constructivePrices.reduce((total, curVal) => {
    return total + +curVal['Услуги'].replacementPrice;
  }, 0);
})

const total = computed(() => {
  return goodsRepairPrice.value + goodsReplacementPrice.value + servicesRepairPrice.value + servicesReplacementPrice.value;
});

const cacheTotal = computed(() => {
  if (!state.constructivePriceCachePercent) {
    return 0;
  }
  return (total.value / 100) * Number(state.constructivePriceCachePercent);
});
const isConstructiveCachePercentError = computed(() => {
  return !state.constructivePriceCachePercent.length
    ? false 
    : (+state.constructivePriceCachePercent > 100 || +state.constructivePriceCachePercent < 0)
});

const isTotalWithoutVATError = computed(() => (constructivePrice: constructivePriceType) => {
  const total = getItemTotal.value(constructivePrice);
  return +total < 0 || !isFinite(+total);
});

const errors = computed(() => state.constructivePrices.some((cp) => isTotalWithoutVATError.value(cp)));

onMounted(() => {
  api.constructs.get().then((r: any) => {
    constructives.value = r.data;

    if (modal.data.projectRegister.constructivePrices?.length) {
      state.constructivePriceCachePercent = modal.data.projectRegister.constructivePriceCachePercent;
      state.constructivePrices = modal.data.projectRegister.constructivePrices.map((cp: any) => ({
        constructiveId: cp.constructiveId,
        constructiveName: `${cp.constructive.nm} ${cp.constructive.group_name}`,
        constructiveNumber: cp.constructive.nm,
        projectRegisterId: cp.id,
        ['Товары']: {
          replacementPrice: +cp['Товары'].replacementPrice || '',
          repairPrice: +cp['Товары'].repairPrice || '',
        },
        ['Услуги']: {
          replacementPrice: +cp['Услуги'].replacementPrice || '',
          repairPrice: +cp['Услуги'].repairPrice || '',
        },
      }));
    } else {
      state.constructivePrices = r.data.map((constructive: IConstructive) => ({
        constructiveId: constructive.id,
        constructiveName: constructive.name,
        constructiveNumber: constructive.nm,
        projectRegisterId: modal.data.projectRegister.id as number,
        ['Товары']: {
          replacementPrice: '',
          repairPrice: '',
        },
        ['Услуги']: {
          replacementPrice: '',
          repairPrice: '',
        },
      }));
    }
  });

});

function send() {
  if (errors.value) {
    state.visibleErrors = true;
    return;
  }
  state.visibleErrors = false;
  state.loader = true;

  api.projectRegister
    .calculate(modal.data.projectRegister.id, {
      constructivePriceCachePercent: state.constructivePriceCachePercent,
      constructivePrices: state.constructivePrices.map(cp => {

      return {
        ...cp,
        details: [
          {
            name: PRICE_NAME.GOODS,
            repairPrice: cp['Товары'].repairPrice,
            replacementPrice: cp['Товары'].replacementPrice,
          },
          {
            name: PRICE_NAME.SERVICES,
            repairPrice: cp['Услуги'].repairPrice,
            replacementPrice: cp['Услуги'].replacementPrice,
          }
        ],
      };
    }) })
    .then(() => modal.ok({ isSuccess: true }))
    .finally(() => (state.loader = false));
}

return (_ctx: any,_cache: any) => {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: __props.id,
    size: "modal-xl",
    title: "Себестоимость проекта"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(PRICE_NAME).GOODS), 1),
            _hoisted_5,
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(PRICE_NAME).SERVICES), 1),
            _hoisted_9,
            _hoisted_10
          ]),
          _hoisted_11
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.constructivePrices, (constructivePrice) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "row my-2",
            key: constructivePrice.constructiveId
          }, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(constructivePrice.constructiveName), 1),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Укажите сумму ремонта",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    class: "mt-2 text-end",
                    modelValue: constructivePrice['Товары'].repairPrice,
                    "onUpdate:modelValue": ($event: any) => ((constructivePrice['Товары'].repairPrice) = $event),
                    mask: { mask: 'Z*', tokens: { Z: { pattern: /[0-9]/ } } },
                    "is-invalid": state.visibleErrors && isTotalWithoutVATError.value(constructivePrice),
                    maxlength: "12"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Укажите сумму замены",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    class: "mt-2 text-end",
                    modelValue: constructivePrice['Товары'].replacementPrice,
                    "onUpdate:modelValue": ($event: any) => ((constructivePrice['Товары'].replacementPrice) = $event),
                    mask: { mask: 'Z*', tokens: { Z: { pattern: /[0-9]/ } } },
                    "is-invalid": state.visibleErrors && isTotalWithoutVATError.value(constructivePrice),
                    maxlength: "12"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Укажите сумму ремонта",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    class: "mt-2 text-end",
                    modelValue: constructivePrice['Услуги'].repairPrice,
                    "onUpdate:modelValue": ($event: any) => ((constructivePrice['Услуги'].repairPrice) = $event),
                    mask: { mask: 'Z*', tokens: { Z: { pattern: /[0-9]/ } } },
                    "is-invalid": state.visibleErrors && isTotalWithoutVATError.value(constructivePrice),
                    maxlength: "12"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Укажите сумму замены",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    class: "mt-2 text-end",
                    modelValue: constructivePrice['Услуги'].replacementPrice,
                    "onUpdate:modelValue": ($event: any) => ((constructivePrice['Услуги'].replacementPrice) = $event),
                    mask: { mask: 'Z*', tokens: { Z: { pattern: /[0-9]/ } } },
                    "is-invalid": state.visibleErrors && isTotalWithoutVATError.value(constructivePrice),
                    maxlength: "12"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_17, _toDisplayString(getItemTotal.value(constructivePrice) ? _unref(formatMoney)(getItemTotal.value(constructivePrice)) : ''), 1)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, _toDisplayString(goodsRepairPrice.value ? _unref(formatMoney)(goodsRepairPrice.value) : ''), 1),
          _createElementVNode("div", _hoisted_21, _toDisplayString(goodsReplacementPrice.value ? _unref(formatMoney)(goodsReplacementPrice.value) : ''), 1),
          _createElementVNode("div", _hoisted_22, _toDisplayString(servicesRepairPrice.value ? _unref(formatMoney)(servicesRepairPrice.value) : ''), 1),
          _createElementVNode("div", _hoisted_23, _toDisplayString(servicesReplacementPrice.value ? _unref(formatMoney)(servicesReplacementPrice.value) : ''), 1),
          _createElementVNode("div", _hoisted_24, _toDisplayString(total.value ? _unref(formatMoney)(total.value) : ''), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите проценты",
              label: "(%)",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  class: "mt-2 text-end",
                  modelValue: state.constructivePriceCachePercent,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.constructivePriceCachePercent) = $event)),
                  "is-invalid": state.visibleErrors && isConstructiveCachePercentError.value,
                  mask: { mask: 'Z*', tokens: { Z: { pattern: /^[0-9.,]+$/ } } },
                  maxlength: "3"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(formatMoney)(cacheTotal.value)), 1)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(" Сохранить ")
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id"]))
}
}

})